import router from '../router/index'
import store from "../store/store";

import { axios, BaseApiUrl ,BaseUrl} from './axios_config';

export function getCustomerList(params) {
    return axios.post(`${BaseApiUrl}/ProductSKU/GetCustomerList`, params);
}

//SKU上传模板
export const DownloadProductSkuExcelTemplate=`${BaseUrl}/template/product/产品SKU导入模板.xlsx`;


//SKU导入URL
export const ImportProductSKUUrl=`${BaseApiUrl}/ProductSKU/ImportProductSKU`;